import React from 'react';
import { FormFeedback, FormGroup, Input, Label, Col, Row } from 'reactstrap';

export const FormSeller = (props) => {

    const {
        name, paternal_surname, maternal_surname, number_phone, email, handleInputChange, validaciones
    } = props;

    const {
        name_valid,
        paternal_surname_valid,
        maternal_surname_valid,

    } = validaciones;

    return (
        <div className='pt-2' >
            <Col sm="12" className=' form-section'>
                <Col md="12" className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="section-title">
                        <i className="pi pi-folder-open"></i>
                        Información General
                    </h6>

                    <small className="section-warning-absolute">
                        <i className="fa fa-exclamation-circle me-1"></i>&nbsp;
                        Complete los campos requeridos
                    </small>
                </Col>
                <Row>
                    <FormGroup className="mb-3 col-6">
                        <Label className="label-admision" >Nombre del vendedor <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleInputChange}
                            invalid={name_valid}
                            className="input-admision"
                            autoComplete="nope"
                        />
                        <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    <FormGroup className="mb-3 col-6 ">
                        <Label className="label-admision">Apellido Paterno <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="paternal_surname"
                            value={paternal_surname}
                            onChange={handleInputChange}
                            invalid={paternal_surname_valid}
                            className="input-admision"
                            autoComplete="nope"

                        />
                        <FormFeedback>El apellido debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    <FormGroup className="mb-3 col-6">
                        <Label className="label-admision">Apellido Materno <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="maternal_surname"
                            value={maternal_surname}
                            onChange={handleInputChange}
                            invalid={maternal_surname_valid}
                            className="input-admision"
                            autoComplete="nope"
                        />
                        <FormFeedback>El apellido debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    <FormGroup className="mb-3 col-6">
                        <Label className="label-admision">Télefono <span className='f-16' style={{ color: "#0079C7" }}>*</span> </Label>
                        <Input
                            type="text"
                            name="number_phone"
                            value={number_phone}
                            onChange={handleInputChange}
                            className="input-admision"
                            autoComplete="nope"
                        />
                    </FormGroup>
                    <FormGroup className="mb-3 col-12">
                        <Label className="label-admision">Correo electrónico<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="email"
                            value={email}
                            onChange={handleInputChange}
                            autoComplete="nope"
                            className="input-admision"
                        />
                    </FormGroup>
                </Row>

            </Col>

        </div>
    )
}
